import React from 'react';
import { 
  HelpCircle, 
  Grid, 
  Ruler, 
  Palette, 
  Scissors, 
  ShoppingBag, 
  Droplet,
  CheckSquare
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по выбору и расчету плитки
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Grid,
      title: 'Выбор размера',
      description: 'Для маленьких помещений выбирайте плитку меньшего размера. Для больших подойдут крупные форматы.'
    },
    {
      icon: Ruler,
      title: 'Ориентация укладки',
      description: 'Диагональная укладка визуально расширяет пространство, но требует больше материала (+15-20%).'
    },
    {
      icon: Palette,
      title: 'Цвет и оттенок',
      description: 'Покупайте плитку одной партии (тона), чтобы избежать различий в оттенке.'
    },
    {
      icon: Scissors,
      title: 'Запас на подрезку',
      description: 'Добавляйте 10-15% для прямой укладки и 15-20% для сложных схем укладки.'
    },
    {
      icon: ShoppingBag,
      title: 'Упаковка',
      description: 'Приобретайте целые упаковки. Хранить чек и образец плитки для возможного добора.'
    },
    {
      icon: Droplet,
      title: 'Затирка',
      description: 'Светлая затирка на темной плитке может оставить разводы. Тестируйте на образце.'
    },
    {
      icon: CheckSquare,
      title: 'Качество материала',
      description: 'Для влажных помещений выбирайте плитку с низким водопоглощением (<3%).'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-fuchsia-500" />
        Советы по выбору плитки
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-fuchsia-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-fuchsia-50 dark:bg-fuchsia-900/20 border border-fuchsia-100 dark:border-fuchsia-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-fuchsia-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-fuchsia-700 dark:text-fuchsia-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-fuchsia-600 dark:text-fuchsia-400 mb-3">
              Перед покупкой плитки рекомендуем проконсультироваться со специалистом для подбора оптимального решения.
            </p>
            <button className="w-full py-1.5 text-xs bg-fuchsia-500 text-white rounded hover:bg-fuchsia-600 transition-colors">
              Найти консультанта
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;